import React from "react";
import { array, string, object } from "prop-types";

import Organism3 from "../Row2/Organism3";
import DfpAd from "../../../dfp-ad";

import "./column.m.css";

const Column = ({ stories, collectionSlug, publisherAttributes }) => {
  return (
    <div styleName="base">
      <div styleName="ad-slot">
        <DfpAd
          adtype={publisherAttributes.lang === "en" ? "EnPalo_HP_336x280_R1" : "Home_336x280_R1"}
          collectionSlug={collectionSlug}
          layoutName="FourteenStories2AdBigFact"
        />
      </div>
      {stories.length > 0 && <Organism3 stories={stories.splice(0, 2)} />}
    </div>
  );
};

Column.propTypes = {
  stories: array.isRequired,
  collectionSlug: string,
  publisherAttributes: object
};

export default Column;
